export default __webpack_public_path__ + "static/media/menuChangePassword.d2863c14.svg";